'use client';

import Chat from '@/public/img/strapi/chat-with-advisor.webp';

import { CTACard } from '@/components/CTACard';
import openChat from '@/helpers/hubspot/openChat';

type ChatCTAProps = {
	testId?: string;
	showImage: boolean;
};

const ChatCTA = (props: ChatCTAProps) => {
	const { testId = 'ChatCTA', showImage } = props;
	return (
		<CTACard
			testId={testId}
			type="button"
			color="sky"
			isStrapiInlineComponent
			onClick={() => openChat()}
		>
			{showImage && (
				<div className="hidden h-44 w-60 overflow-hidden rounded-l-3xl lg:flex xl:w-70">
					<CTACard.Image
						src={Chat}
						alt="HVAC.com Chat with an Advisor"
						className="min-h-full object-cover"
					/>
				</div>
			)}
			<div className="flex-1 px-6 py-4">
				<CTACard.Badge color="sky" compact>
					Live Chat
				</CTACard.Badge>
				<CTACard.Title compact className="pb-0.5">
					Chat with an Advisor
				</CTACard.Title>
				<CTACard.Content compact isStrapiInlineComponent className="pb-2">
					Have an HVAC question? Our experts are here to help!
				</CTACard.Content>
				<CTACard.Action color="sky" compact>
					Get help now
				</CTACard.Action>
			</div>
		</CTACard>
	);
};

export default ChatCTA;
